import {connect} from "react-redux";
import BusinessConfig from "./businessConfig";
import {bindActionCreators} from "redux";
import {createSiteInspectionForm, inspectionCreated, getAllCity} from "../../../service/Lead/action";
import {documentUploadUrlPublic} from "../../../service/fileUpload/action";

const mapStateToProps = (state) => ({
    lead:state.Lead.lead,
    inspectionCreatedData:state.Lead.inspectionCreatedData,
    getCity:state.Lead.getCity,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            createSiteInspectionForm,
            documentUploadUrlPublic,
            inspectionCreated,
            getAllCity
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(BusinessConfig);
